<template>
  <div>
    <v-layout justify-center>
      <v-flex
        xs12
        sm12
        md10
        lg5
        xl5
      >
        <v-card
          flat
          style="border: 1px solid #ddd; border-radius: 8px"
          class="my-4"
        >
          <h4 class="px-3 mb-0">Check Rate</h4>
          <v-card-text>
            <div class="tab-btn-container mb-4">
              <div class="import-export-btn">
                <div
                  @click="activeTab = 'import'"
                  class="tab-btn"
                  :class="activeTab == 'import' ? 'active-tab-btn' : ''"
                >
                  Import
                </div>
              </div>
              <div class="import-export-btn">
                <div
                  @click="activeTab = 'export'"
                  class="tab-btn"
                  :class="activeTab == 'export' ? 'active-tab-btn' : ''"
                >
                  Export
                </div>
              </div>
            </div>

            <!-- Import -->
            <form
              v-if="activeTab == 'import'"
              @submit.prevent="submitImport()"
            >
              <div class="row">
                <div class="col-xs-12">
                  <v-select
                    autocomplete
                    :items="filteredCountryList"
                    item-value="value"
                    v-model="importForm.from_country_id"
                    :error-messages="errors.collect('Origin Country')"
                    data-vv-name="Origin Country"
                    label="Origin Country*"
                    v-validate="'required'"
                    @input="importCountrySelected(importForm.from_country_id)"
                  />
                </div>
                <div class="
                    col-xs-12">
                  <v-btn-toggle v-model="importForm.is_document">
                    <v-btn
                      flat
                      depressed
                      :value="true"
                      class="btn-group"
                      :color="importForm.is_document ? 'primary' : ''"
                    >
                      Document
                    </v-btn>
                    <v-btn
                      flat
                      depressed
                      :value="false"
                      class="btn-group"
                      :color="importForm.is_document ? '' : 'primary'"
                    >
                      None Document
                    </v-btn>
                  </v-btn-toggle>
                </div>
                <div class="col-xs-12">
                  <v-text-field
                    label="Quantity*"
                    v-model="importForm.quantity"
                    :error-messages="errors.collect('Quantity')"
                    v-validate="'required|numeric|min_value:1'"
                    data-vv-name="Quantity"
                    type="number"
                  />
                </div>
                <div class="col-xs-9">
                  <v-text-field
                    label="Weight Per Package*"
                    v-model="importForm.weight"
                    :error-messages="errors.collect('Weight Per Package')"
                    v-validate="'numeric|min_value:0.1'"
                    data-vv-name="Weight Per Package"
                  />
                </div>
                <div class="col-xs-2">
                  <v-select
                    :items="weightUnitList"
                    v-model="importForm.weight_unit"
                    :error-messages="errors.collect('Weight Unit')"
                    data-vv-name="Weight Unit"
                    v-validate="'required'"
                    autocomplete
                    readonly
                  />
                </div>

                <div class="col-xs-12">Dimensions Per Package <span class="inch-div">(inch)</span></div>
                <div class="col-xs-4">
                  <v-text-field
                    v-model="importForm.size_l"
                    label="Length"
                    type="number"
                  />
                </div>
                <div class="col-xs-4">
                  <v-text-field
                    v-model="importForm.size_w"
                    label="Width"
                    type="number"
                  />
                </div>
                <div class="col-xs-4">
                  <v-text-field
                    v-model="importForm.size_h"
                    label="Height"
                    type="number"
                  />
                </div>

                <div class="col-xs-6">
                  <v-btn
                    style="height: auto"
                    color="primary"
                    depressed
                    type="submit"
                  >
                    Show Rate
                  </v-btn>
                </div>
                <div class="col-xs-6 text-right pt-2">
                  <div
                    v-if="importCheckRateData"
                    class="response-div"
                  >
                    {{ importCheckRateData.price }} USD
                  </div>
                </div>
              </div>
            </form>

            <!-- Export -->
            <form
              v-if="activeTab == 'export'"
              @submit.prevent="submitExport()"
            >
              <div class="row">
                <div class="col-xs-12">
                  <v-select
                    autocomplete
                    :items="filteredCountryList"
                    item-value="value"
                    v-model="exportForm.to_country_id"
                    :error-messages="errors.collect('Destination Country')"
                    data-vv-name="Destination Country"
                    label="Destination Country*"
                    v-validate="'required'"
                  />
                </div>
                <div class="col-xs-12">
                  <v-btn-toggle v-model="exportForm.is_document">
                    <v-btn
                      flat
                      depressed
                      :value="true"
                      class="btn-group"
                      :color="exportForm.is_document ? 'primary' : ''"
                    >
                      Document
                    </v-btn>
                    <v-btn
                      flat
                      depressed
                      :value="false"
                      class="btn-group"
                      :color="exportForm.is_document ? '' : 'primary'"
                    >
                      None Document
                    </v-btn>
                  </v-btn-toggle>
                </div>
                <div class="col-xs-12">
                  <v-text-field
                    label="Quantity*"
                    v-model="exportForm.quantity"
                    :error-messages="errors.collect('Quantity')"
                    v-validate="'required|numeric|min_value:1'"
                    data-vv-name="Quantity"
                    type="number"
                  />
                </div>
                <div class="col-xs-9">
                  <v-text-field
                    label="Weight Per Package*"
                    v-model="exportForm.weight"
                    :error-messages="errors.collect('Weight Per Package')"
                    v-validate="'numeric|min_value:0.1'"
                    data-vv-name="Weight Per Package"
                  />
                </div>
                <div class="col-xs-2">
                  <v-select
                    :items="weightUnitList"
                    v-model="exportForm.weight_unit"
                    :error-messages="errors.collect('Weight Unit')"
                    data-vv-name="Weight Unit"
                    v-validate="'required'"
                    autocomplete
                  />
                </div>

                <div class="col-xs-12">Dimensions Per Package <span class="inch-div">(inch)</span></div>
                <div class="col-xs-4">
                  <v-text-field
                    v-model="exportForm.size_l"
                    label="Length"
                    type="number"
                  />
                </div>
                <div class="col-xs-4">
                  <v-text-field
                    v-model="exportForm.size_w"
                    label="Width"
                    type="number"
                  />
                </div>
                <div class="col-xs-4">
                  <v-text-field
                    v-model="exportForm.size_h"
                    label="Height"
                    type="number"
                  />
                </div>

                <div class="col-xs-6">
                  <v-btn
                    style="height: auto"
                    color="primary"
                    depressed
                    type="submit"
                  >
                    Show Rate
                  </v-btn>
                </div>
                <div class="col-xs-6 text-right pt-2">
                  <div
                    v-if="exportCheckRateData"
                    class="response-div"
                  >
                    {{ exportCheckRateData.price }} USD
                  </div>
                </div>
              </div>
            </form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  data() {
    return {
      activeTab: 'import',
      weightUnitList: [
        { text: 'KG', value: 'kg' },
        { text: 'LB', value: 'lb' }
      ],
      importCheckRateData: null,
      exportCheckRateData: null,
      countryList: [],
      importForm: {
        from_country_id: null,
        is_document: true,
        quantity: null,
        weight: null,
        weight_unit: 'kg',
        size_l: null,
        size_w: null,
        size_h: null
      },
      exportForm: {
        to_country_id: null,
        is_document: true,
        quantity: null,
        weight: null,
        weight_unit: 'kg',
        size_l: null,
        size_w: null,
        size_h: null
      }
    }
  },

  computed: {
    filteredCountryList() {
      if (this.activeTab === 'import') {
        return this.countryList.filter(item => [43, 219].includes(item.value))
      }

      return this.countryList
    }
  },

  mounted() {
    this.getCountryList()
  },

  methods: {
    importCountrySelected(countryId) {
      if (countryId === 219) {
        this.importForm.weight_unit = 'lb'
      } else if (countryId === 43) {
        this.importForm.weight_unit = 'kg'
      }
    },

    getCountryList() {
      let token = localStorage.getItem('access_token')
      Axios
        .get('api/country/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.countryList = response.data.map((item) => {
            return { text: item.country_name, value: item.country_id }
          })
        })
    },

    submitImport() {
      // this.$validator.validateAll().then(res => {
      // if (res) {
      let token = localStorage.getItem('access_token')
      Axios
        .post('api/import-check-rate', this.importForm, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.importCheckRateData = response.data.data
        })
      // }
      // })
    },

    submitExport() {
      // this.$validator.validateAll().then(res => {
      // if (res) {
      let token = localStorage.getItem('access_token')
      Axios
        .post('api/export-check-rate', this.exportForm, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.exportCheckRateData = response.data.data
        })
      // }
      // })
    }
  }
}
</script>

<style >
.btn-group .btn__content {
  min-width: 130px !important;
}

.tab-btn-container {
  display: flex;
  flex-direction: row;
  background: #eee;
  border-radius: 8px;
}
.import-export-btn {
  width: 50%;
  text-align: center;
  padding: 6px;
}
.tab-btn {
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s;
}

.active-tab-btn {
  background-color: #006b8d;
  color: white;
}

.response-div {
  font-size: 20px;
  font-weight: 500;
  background-color: #006b8d;
  color: white;
  display: inline;
  padding: 6px 8px;
  border-radius: 4px;
}

.inch-div {
  font-style: italic;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/checkRate.vue